import { CarouselContainer } from '../Carousel/Carousel';
import { IconCard, IconCardProps } from '../IconCard/IconCard';

interface IconCardsCarouselProps {
  heading: string;
  items: IconCardProps[];
}

const IconCardsCarousel = ({ heading, items = [] }: IconCardsCarouselProps) => {
  return (
    <>
      <h2>{heading}</h2>
      <CarouselContainer useCarousel={items.length > 2}>
        {items.map((item, i) => (
          <IconCard
            key={`${i}`}
            icon={item.icon}
            title={item.title}
            contents={item.contents}
            fillColour={item.fillColour}
          />
        ))}
      </CarouselContainer>
    </>
  );
};

export default IconCardsCarousel;
